import React from 'react'
import Header from '../components/Header'
import styled from 'styled-components';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

const Layout = () => {
    const location = useLocation();
    const pathname = location.pathname;
    console.log(pathname, "pathname")
    return (
        <LayoutWrapper>
            {pathname !== "/landing/create-profile" && pathname !== "/landing/congratulations" && pathname !== "/landing/schedule" && pathname !== "/landing/payment" && <div>
                <Header />
            </div>}

            <div className="landingSidebar">
                <Sidebar />
            </div>
            <div>
                <Outlet />
            </div>
        </LayoutWrapper>
    )
}

export default Layout;

const LayoutWrapper = styled.div``;